/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinTeamResponse
 */
export interface JoinTeamResponse {
    /**
     * 
     * @type {string}
     * @memberof JoinTeamResponse
     */
    team: JoinTeamResponseTeamEnum;
    /**
     * 
     * @type {number}
     * @memberof JoinTeamResponse
     */
    teamAPoints: number;
    /**
     * 
     * @type {number}
     * @memberof JoinTeamResponse
     */
    teamBPoints: number;
}


/**
 * @export
 */
export const JoinTeamResponseTeamEnum = {
    A: 'A',
    B: 'B'
} as const;
export type JoinTeamResponseTeamEnum = typeof JoinTeamResponseTeamEnum[keyof typeof JoinTeamResponseTeamEnum];


/**
 * Check if a given object implements the JoinTeamResponse interface.
 */
export function instanceOfJoinTeamResponse(value: object): value is JoinTeamResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('teamAPoints' in value) || value['teamAPoints'] === undefined) return false;
    if (!('teamBPoints' in value) || value['teamBPoints'] === undefined) return false;
    return true;
}

export function JoinTeamResponseFromJSON(json: any): JoinTeamResponse {
    return JoinTeamResponseFromJSONTyped(json, false);
}

export function JoinTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': json['team'],
        'teamAPoints': json['teamAPoints'],
        'teamBPoints': json['teamBPoints'],
    };
}

export function JoinTeamResponseToJSON(json: any): JoinTeamResponse {
    return JoinTeamResponseToJSONTyped(json, false);
}

export function JoinTeamResponseToJSONTyped(value?: JoinTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': value['team'],
        'teamAPoints': value['teamAPoints'],
        'teamBPoints': value['teamBPoints'],
    };
}

